import React, { Fragment, useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import { Col, Dropdown, DropdownMenu, DropdownToggle, Row } from "reactstrap"
import { getModules as onGetModules } from "store/actions"
import {
  beneficaryListModuleId,
  claimReportV2ModuleId,
  lossRatioReportModuleId,
} from "utils/modulesIds"

const ShortcutMenu = () => {
  const dispatch = useDispatch()
  const { modules } = useSelector((state) => ({
    modules: state.Sidebar.modules,
  }))
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  // getting all modules when the component did mount
  useEffect(() => {
    if (modules.length === 0) {
      dispatch(onGetModules())
    }
  }, [modules.length])

  const shortcuts = [
    claimReportV2ModuleId,
    lossRatioReportModuleId,
    beneficaryListModuleId,
  ]

  const { subModules, isShortCutMenu } = useMemo(() => {
    const subs = modules.flatMap((module) => module?.sub_modules)
    // check if any of shorcut modules are already in permissions
    const isShortCutIncluded = subs.some((item) => shortcuts.includes(item?.id))
    return {
      subModules: subs?.length ? subs : [],
      isShortCutMenu: isShortCutIncluded,
    }
  }, [modules])

  return (
    <Dropdown
      className="d-none d-lg-inline-block ms-1"
      isOpen={isMenuOpen}
      toggle={() => {
        setIsMenuOpen(!isMenuOpen)
      }}
    >
      {/* Shortcuts Menu Toggler */}

      <DropdownToggle
        className="btn header-item noti-icon"
        disabled={!isShortCutMenu}
        tag="button"
      >
        <i className="bx bx-customize" />
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-lg dropdown-menu-end">
        <div className="px-lg-2">
          <Row className="no-gutters">
            <Fragment>
              {subModules.length > 0 &&
                subModules.map(
                  (sub_module) =>
                    shortcuts.includes(sub_module.id) && (
                      <Col key={sub_module.id}>
                        <Link
                          className="dropdown-icon-item"
                          style={{ width: "140px" }}
                          to={`/${sub_module.name
                            .toLowerCase()
                            .replace(" ", "-")}`}
                        >
                          <i className={`${sub_module.icon} font-size-24`}></i>
                          <span>{sub_module.title}</span>
                        </Link>
                      </Col>
                    )
                )}
            </Fragment>
          </Row>
        </div>
      </DropdownMenu>
    </Dropdown>
  )
}

export default ShortcutMenu
